"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreUpdateEvents = exports.KitchenDisplayActions = exports.DeviceEventActions = exports.SubscriptionTopics = void 0;
var SubscriptionTopics;
(function (SubscriptionTopics) {
    SubscriptionTopics["DEVICE_EVENTS_TOPIC"] = "DEVICE_EVENTS";
    SubscriptionTopics["KITCHEN_DISPLAY_EVENTS_TOPIC"] = "KITCHEN_DISPLAY_EVENTS";
    SubscriptionTopics["UPDATE_PRODUCTS_AVAILABILITY_EVENT"] = "UPDATE_PRODUCTS_AVAILABILITY_EVENT";
    SubscriptionTopics["UPDATE_CUSTOMER_INFO_EVENT"] = "UPDATE_CUSTOMER_INFO_EVENT";
    SubscriptionTopics["UPDATE_STORE_EVENT"] = "UPDATE_STORE_EVENT";
    SubscriptionTopics["UPDATE_CATALOGUE_EVENT"] = "UPDATE_CATALOGUE_EVENT";
})(SubscriptionTopics = exports.SubscriptionTopics || (exports.SubscriptionTopics = {}));
var DeviceEventActions;
(function (DeviceEventActions) {
    DeviceEventActions["LOGOUT_ACTION"] = "LOGOUT";
    DeviceEventActions["UN_PAIR_CDS_ACTION"] = "UN_PAIR_CDS";
    DeviceEventActions["PAIR_CDS_ACTION"] = "PAIR_CDS";
})(DeviceEventActions = exports.DeviceEventActions || (exports.DeviceEventActions = {}));
var KitchenDisplayActions;
(function (KitchenDisplayActions) {
    KitchenDisplayActions["LOGOUT_ACTION"] = "LOGOUT";
})(KitchenDisplayActions = exports.KitchenDisplayActions || (exports.KitchenDisplayActions = {}));
var StoreUpdateEvents;
(function (StoreUpdateEvents) {
    StoreUpdateEvents["UPDATE_STORE_STATUS"] = "UPDATE_STORE_STATUS";
    StoreUpdateEvents["PAUSE_ORDERS"] = "PAUSE_ORDERS";
    StoreUpdateEvents["DELAY_ORDERS"] = "DELAY_ORDERS";
})(StoreUpdateEvents = exports.StoreUpdateEvents || (exports.StoreUpdateEvents = {}));
//# sourceMappingURL=subscriptionEvents.js.map